exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.requisition {\n  display: block;\n  padding: 0.5rem;\n  text-align: center;\n  font-size: 12px;\n  border-radius: 4px;\n  background-color: #f2f2f2;\n  cursor: not-allowed;\n}\n.requisition.link {\n    background-color: #EAF0F6;\n    cursor: pointer;\n    color: #455666;\n    text-decoration: none;\n}\n.requisition.link:hover {\n      text-decoration: underline;\n}\n", ""]);

// exports
